import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import queryString from "query-string"
import Actions from "../../Redux/Actions"
import { WithDrawerConsumer } from "../../Contexts/DrawerContext/withDrawerConsumer"
import SecondaryNavDrawer from "../SecondaryNavDrawer/SecondaryNavDrawer"
import MobileNavItem from "../MobileNavItem/MobileNavItem"
import { ADDITIONAL_COURSE_ID } from "../../Constants/courses"
import { buildWorkshopLocation } from "../../Utils/workshopNavigation"
import {
  getLastVisitedPartId,
  getOrderedPartIds,
  getSubcoursesForModule,
  isEMpoweredModuleLocked,
  isSubcourseLocked
} from "../../Utils/empoweredProgress"
import { RightArrow } from "../../Icons/RightArrow"

const resolveWorkshopCourseContext = (location, user) => {
  const qs = queryString.parse(location.search)
  const courseIdFromQuery = qs.courseId ? Number(qs.courseId) : null
  const courseId = location.state?.courseId ?? courseIdFromQuery ?? null
  let courseName = location.state?.courseName

  if (!courseName && Number(courseId) === ADDITIONAL_COURSE_ID) {
    const enrolled = user?.enrolled_courses?.find(
      (c) => Number(c.id) === ADDITIONAL_COURSE_ID
    )
    courseName = enrolled?.name
  }

  if (!courseName) {
    courseName = "Pursue Your Purpose"
  }

  return { courseId, courseName }
}

function resolveActiveModuleIdFromProps(props) {
  const modules = props.modules || []
  if (!modules.length) return null

  const qs = queryString.parse(props.location?.search || "")
  const urlPartId = qs.partId != null ? Number(qs.partId) : null
  const currentPartId = Number(props.currentPartId)
  const partId =
    urlPartId > 0
      ? urlPartId
      : currentPartId > 0
        ? currentPartId
        : null

  const pypLike = {
    partsByModuleId: props.partsByModuleId,
    subcoursesByModuleId: props.subcoursesByModuleId
  }

  if (partId) {
    for (const module of modules) {
      const ordered = getOrderedPartIds(pypLike, module.id)
      if (ordered.includes(Number(partId))) return module.id
      const subcourses = getSubcoursesForModule(pypLike, module.id)
      if (
        subcourses.some((s) =>
          (s.partIds || []).map(Number).includes(Number(partId))
        )
      ) {
        return module.id
      }
    }
  }

  const pathTitle = props.match?.params?.module
  if (pathTitle) {
    const match = modules.find((m) => m.title === pathTitle)
    if (match) return match.id
  }

  return modules[0]?.id ?? null
}

export const PYPNavDrawer = (props) => {
  const isLoading = !props.initialized && !props.modules.length
  const { courseId, courseName } = resolveWorkshopCourseContext(
    props.location,
    props.user
  )
  const drawerTitle =
    props.currentCourseName || courseName || "Pursue Your Purpose"
  const isEMpowered = Number(courseId) === ADDITIONAL_COURSE_ID

  const [expandedModuleId, setExpandedModuleId] = useState(() =>
    resolveActiveModuleIdFromProps(props)
  )

  useEffect(() => {
    props.initializePYP(
      props.match.params.module || "Welcome to COMMIT",
      courseName,
      courseId
    )
  }, [])

  useEffect(() => {
    if (!isEMpowered) return
    const nextActive = resolveActiveModuleIdFromProps(props)
    if (
      nextActive != null &&
      Number(expandedModuleId) !== Number(nextActive)
    ) {
      setExpandedModuleId(nextActive)
    }
    // Sync only when navigation target changes (not on accordion toggle).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isEMpowered,
    props.currentPartId,
    props.currentModuleId,
    props.location?.search,
    props.match?.params?.module,
    props.modules?.length
  ])

  const toggleModule = (moduleId) => {
    setExpandedModuleId((prev) =>
      Number(prev) === Number(moduleId) ? null : moduleId
    )
  }

  const processOptions = (option) => {
    const useCourseId =
      courseId != null && Number(courseId) === ADDITIONAL_COURSE_ID
    return {
      ...option,
      isSelected: props.match.params.module === option.title,
      route: `/workshop/${option.title}${
        useCourseId ? `?courseId=${courseId}` : ""
      }`
    }
  }

  const addStatus = (pypModule) => {
    const unlocked = props.userModules.find((userModule) => {
      return userModule.id === pypModule.id
    })

    return {
      ...pypModule,
      isUnlocked: Boolean(unlocked)
    }
  }

  const currentPartId = Number(props.currentPartId)
  const qs = queryString.parse(props.location.search)
  const urlPartId = qs.partId != null ? Number(qs.partId) : null

  let navOptions

  if (isEMpowered && props.modules.length) {
    navOptions = []
    const pypLike = {
      modules: {
        allIds: props.modules.map((m) => m.id)
      },
      unlockedUserModules: props.unlockedUserModules,
      partsByModuleId: props.partsByModuleId,
      subcoursesByModuleId: props.subcoursesByModuleId,
      navigation: {
        moduleNavigationMetaData: props.moduleNavigationMetaData
      }
    }

    props.modules.forEach((module) => {
      const moduleIsLocked = isEMpoweredModuleLocked(pypLike, module.id)
      const isExpanded = Number(expandedModuleId) === Number(module.id)
      navOptions.push(
        <MobileNavItem
          style={{ padding: "10px 40px 4px 40px" }}
          hasSecondaryNavigation={false}
          key={`header-${module.id}`}
          clickHandler={() => toggleModule(module.id)}
          isSelected={false}
        >
          <p
            style={{
              gridColumnStart: 2,
              opacity: moduleIsLocked ? 0.45 : 0.85,
              fontFamily: "Lato-Bold",
              fontSize: "16px",
              margin: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "8px",
              width: "100%"
            }}
          >
            <span style={{ flex: 1, minWidth: 0 }}>{module.title}</span>
            <span
              style={{
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                transform: isExpanded ? "rotate(90deg)" : "none"
              }}
            >
              <RightArrow
                width="12"
                height="18"
                stroke="#FFF"
                strokeWidth="2"
              />
            </span>
          </p>
        </MobileNavItem>
      )

      if (!isExpanded) return

      const subcourses = getSubcoursesForModule(pypLike, module.id)
      const orderedPartIds = getOrderedPartIds(pypLike, module.id)
      const lastVisitedPartId = getLastVisitedPartId(pypLike, module.id)

      subcourses.forEach((subcourse, j) => {
        const partIds = (subcourse.partIds || []).map(Number)
        const subLocked = isSubcourseLocked({
          orderedPartIds,
          subcourse,
          subcourseIndex: j,
          lastVisitedPartId,
          moduleLocked: moduleIsLocked
        })
        const itemLocked = moduleIsLocked || subLocked
        const isSelected =
          (currentPartId > 0 && partIds.includes(currentPartId)) ||
          (urlPartId > 0 && partIds.includes(urlPartId))
        const location = buildWorkshopLocation(
          module.title,
          {
            currentCourseId: courseId,
            currentCourseName: drawerTitle
          },
          "/content",
          subcourse.firstPartId
        )
        const route = `${location.pathname}${location.search}`

        navOptions.push(
          <MobileNavItem
            style={{ padding: "6px 40px 6px 56px" }}
            hasSecondaryNavigation={false}
            key={`${module.id}-${subcourse.firstPartId}-${j}`}
            isSelected={isSelected}
            route={itemLocked ? undefined : route}
            clickHandler={itemLocked ? () => {} : undefined}
          >
            <p
              style={{
                gridColumnStart: 2,
                opacity: itemLocked ? 0.5 : isSelected ? 1 : 0.9,
                margin: 0
              }}
            >
              {subcourse.label}
            </p>
          </MobileNavItem>
        )
      })
    })
  } else {
    navOptions = props.modules
      .map(processOptions)
      .map(addStatus)
      .map((option, i) => {
        return (
          <MobileNavItem
            style={{ padding: "10px 40px 10px 40px" }}
            hasSecondaryNavigation={false}
            {...option}
            key={i}
          >
            <p
              style={{
                gridColumnStart: 2,
                opacity: option.isUnlocked || option.isSelected ? 1 : 0.5
              }}
            >
              {option.title}
            </p>
          </MobileNavItem>
        )
      })
  }

  return (
    <>
      <SecondaryNavDrawer
        navOptions={navOptions}
        title={drawerTitle}
        titleStyles={{ fontSize: "24px" }}
        isLoading={isLoading}
      />
    </>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => ({
  ...props,
  modules:
    state.pyp.modules && state.pyp.modules.allIds
      ? state.pyp.modules.allIds.map(
          (moduleId) => state.pyp.modules.byId[moduleId]
        )
      : [],
  userModules: state.user.user.modules,
  user: state.user.user,
  currentCourseName: state.pyp.navigation.currentCourseName,
  currentPartId: state.pyp.navigation.currentPartId,
  currentModuleId: state.pyp.navigation.currentModuleId,
  unlockedUserModules: state.pyp.unlockedUserModules,
  subcoursesByModuleId: state.pyp.subcoursesByModuleId,
  partsByModuleId: state.pyp.partsByModuleId,
  moduleNavigationMetaData: state.pyp.navigation.moduleNavigationMetaData,
  initialized: state.pyp.initialized
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithDrawerConsumer(PYPNavDrawer))
)
